import { Paper, CssBaseline } from "@mui/material";
import { Container, Box } from "@mui/system";
import { Outlet } from "react-router";
import { loginStyles } from "../_styles/login.styles";
import { AuthFooter } from "../pages/login/_components/authFooter.screen";

const logoImg = require('../_assets/images/Logo-Standard.png');

export const AuthScreen = () => {
    return (
        <div style={loginStyles.appScreen} id="app-screen">
            <Container component="main" maxWidth="sm" style={loginStyles.mainBackground}>
                <div style={loginStyles.ieBox}>
                    <Paper elevation={3} style={loginStyles.logoBox}>
                        <img style={loginStyles.appLogo} src={logoImg}></img>
                    </Paper>

                    <Paper elevation={3} style={loginStyles.loginBox}>

                        <CssBaseline />

                        <Outlet></Outlet>

                        <Box mt={8}>
                            <AuthFooter />
                        </Box>
                    </Paper>
                </div>
            </Container>
        </div>
    );
}